/** CSRF for fetch: prefer XSRF-TOKEN cookie (Inertia Rails refreshes it each response). */
function readXsrfCookie(): string {
  if (typeof document === "undefined") return ""
  const raw = document.cookie
    .split("; ")
    .find((part) => part.startsWith("XSRF-TOKEN="))
    ?.slice("XSRF-TOKEN=".length)
  if (!raw) return ""
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

function readMetaCsrfToken(): string {
  if (typeof document === "undefined") return ""
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? ""
}

/** Keep meta in sync with the live token (shared prop or XSRF cookie). */
export function syncCsrfMeta(token?: string | null): void {
  if (typeof document === "undefined") return
  const next = token || readXsrfCookie()
  if (!next) return
  document.querySelector('meta[name="csrf-token"]')?.setAttribute("content", next)
}

/**
 * CSRF for non-Inertia fetch (POST/PATCH/…).
 * Cookie first — after login `reset_session` Inertia Rails writes a fresh XSRF-TOKEN
 * while meta can lag until the next navigate sync.
 */
export function getCsrfToken(): string {
  return readXsrfCookie() || readMetaCsrfToken()
}

/** Alias used by scale-sheet APIs. */
export const readCsrfToken = getCsrfToken
